import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const Logout : React.FC = () => {
    const navigate = useNavigate();

    useEffect(()=>{
        window.localStorage.clear();
        window.sessionStorage.clear();
        navigate("/")
    }, [])

    return (
        <></>
    )
}

export default Logout;